import { render, staticRenderFns } from "./ExtraLinks.vue?vue&type=template&id=6c031fa5"
import script from "./ExtraLinks.vue?vue&type=script&lang=ts"
export * from "./ExtraLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports